<template>
  <div class="section__journey">
    <div class="section__content">
      <SectionHeader v-if="content.header" :text="content.header" v-reveal />
      <h1 class="title --home" v-reveal="{ delay: 200 }">
        <span>{{ `${title[0]} ` }}</span>
        <BannerCheckmark />
        <span>{{ ` ${title[1]}` }}</span>
      </h1>
      <p v-reveal="{ delay: 250 }">{{ content.description }}</p>
      <LangRouterLink
        :to="{ name: 'about' }"
        class="button --top"
        :title="content.label"
        v-reveal="{ delay: 300 }"
        >{{ content.label }}</LangRouterLink
      >
    </div>
  </div>
</template>

<script>
import { LangRouterLink } from '@/components/global'
import { BannerCheckmark, SectionHeader } from '@/components/small'

export default {
  name: 'CategoriesBannerContent',
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
  components: { BannerCheckmark, LangRouterLink, SectionHeader },
  computed: {
    title() {
      return this.content.title.split(' _ ')
    },
  },
}
</script>
